var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7052 15H39.2948C36.9229 15 35 16.8507 35 19.1336V42.8664C35 45.1493 36.9229 47 39.2948 47H41.7052C44.0771 47 46 45.1493 46 42.8664V19.1336C46 16.8507 44.0771 15 41.7052 15Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0956 15H20.9044C18.7481 15 17 16.8507 17 19.1336V42.8664C17 45.1493 18.7481 47 20.9044 47H23.0956C25.2519 47 27 45.1493 27 42.8664V19.1336C27 16.8507 25.2519 15 23.0956 15Z",
    fill: "#9C9C9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7052 16H40.2948C37.9229 16 36 17.9085 36 20.2627V44.7373C36 47.0915 37.9229 49 40.2948 49H42.7052C45.0771 49 47 47.0915 47 44.7373V20.2627C47 17.9085 45.0771 16 42.7052 16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7052 16H22.2948C19.9229 16 18 17.9085 18 20.2627V44.7373C18 47.0915 19.9229 49 22.2948 49H24.7052C27.0771 49 29 47.0915 29 44.7373V20.2627C29 17.9085 27.0771 16 24.7052 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.77c87e175f667ffe969139ad41cb771c.svg";
export { ForwardRef as ReactComponent };